import apiAction from 'common/redux/actions/apiAction';
import { POST_DIRECT_REPORTEE_ACTIONS_POPUP_FILTER } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

/****
 * POST POPUP LISTING DETAILS
 ****/
const getDirectReporteeActionPopupFilterData = data => {
  return {
    type: 'GET_DIRECT_REPORTEE_ACTION_POPUP_FILTER_DATA',
    payload: data,
  };
};

export const DirectReporteePopupFilterData = configParams => {
  return apiAction.postAPI({
    url: POST_DIRECT_REPORTEE_ACTIONS_POPUP_FILTER(configParams.actionsType),
    data: configParams,
    onSuccess: getDirectReporteeActionPopupFilterData,
    onFailure: err => logError('Error occured in fetching Direct Reportee Action PopupUp Filter data.:', err),
    label: 'FETCHT_DIRECT_REPORTEE_ACTION_POPUP_FILTER_DATA',
  });
};